export class VideoRequest {
	/// First and Last Name
	NAME: string = ""; 
	/// Company
	COMPANY:string = ""; 
	EMAIL: string = ""; 
	PHONE: string = ""; 
	ADDITIONAL_INFO: string = ""; 
	REASON:string = ""; 
	CAMERAS:string = ""; 
	TIME_START?: number; 
	TIME_END?: number; 
	USER_TYPE?: number; 
	CreationDate?: Date; 
	START_TIME: string = "";
	END_TIME: string = ""; 
	Fatality: string = "";
	Urgent?: boolean;

	constructor() {
	}

}